/**
 * @file   src\mobile\pages\SettingsCheckEmail.js
 * @brief  This file is responsible check email page
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { pageURLs } from "../../constants/pageURLs";
import CountdownTimer from "../components/Common/CountdownTimer";
import { resendEmail } from "../../services/signupService";
import { toast } from "react-toastify";

const SettingsCheckEmail = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const newEmailId = location.state && location.state["newEmailId"];
  /**
   * To handle resend email
   */
  const resentEmail = () => {
    const userInfo = {
      Email: newEmailId,
      Process: "email_change",
    };
    resendEmail(userInfo).then((response) => {
      if (response) {
        if (_.get(response, "errorCode", false) === 0) {
          toast.success("Successfully resend the Email.");
        } else {
          toast.error(response.message);
        }
      }
    });
  };

  const openDefaultEmailApp = () => {
    window.location.href = `mailto:${newEmailId}`;
  };

  return (
    <>
      <div className="gitcha-main-wrapper pb-0">
        <div className="content-wrapper h-100">
          <div className="inner-layout-header-new bg-white ">
            <div className="top-three-comp-header w-100 flex-column top-three-comp-headerborder">
              <div className="top-three-comp-header-inner w-100">
                <a
                  className="back-link-btn"
                  href={void 0}
                  onClick={() => navigate(pageURLs.mobileAccountSettings)}
                >
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M10.1003 5.39972C10.3932 5.69262 10.3932 6.16749 10.1003 6.46038L5.31066 11.2501H20.5C20.9142 11.2501 21.25 11.5858 21.25 12.0001C21.25 12.4143 20.9142 12.7501 20.5 12.7501H5.31066L10.1003 17.5397C10.3932 17.8326 10.3932 18.3075 10.1003 18.6004C9.80744 18.8933 9.33256 18.8933 9.03967 18.6004L2.96967 12.5304C2.82902 12.3897 2.75 12.199 2.75 12.0001C2.75 11.8011 2.82902 11.6104 2.96967 11.4697L9.03967 5.39972C9.33256 5.10683 9.80744 5.10683 10.1003 5.39972Z"
                      fill="#1B1C1E"
                    />
                  </svg>
                </a>
                <div className="heading">Edit Email</div>
                <div className="p-0 toplinks-mobile">
                  <div className="topbar-links notif-delete-btn d-none"></div>
                </div>
              </div>
            </div>
          </div>

          <div className="inner-layout-content-new h-100 ">
            <div className=" h-100  bg-grey-variant">
              <div className="checkEmailWrap">
                <div className="pb-3">
                  <span className="postboxicon"></span>
                  <h2>Check your email</h2>

                  <p className="mb-1">We’ve sent a login link to </p>
                  <a href={void 0}>{newEmailId}</a>
                </div>
                <button
                  type="button"
                  className="btn btn-primary w-100 mb-4"
                  onClick={() => openDefaultEmailApp()}
                >
                  Open email app
                </button>
                <div className="time">
                  <CountdownTimer resentEmail={resentEmail}></CountdownTimer>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SettingsCheckEmail;
